import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "../../components/generalComponents/Table";
import {
  fetchOrderHistory,
  fetchSingleOrderData,
  setOrderId,
} from "../../services/orderHistory/actions";
import { calculateOrderTotal } from "../../utils/priceUtils";

function SingleOrder(props) {
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState("");

  useEffect(() => {
    fetchSingleOrderData(props.orderId, setOrder);
    setLoading(false);
    // disable fetchAll dependency warning
    // eslint-disable-next-line
  }, [props.orderId]);

  const orderHistoryColumnsTable = [
    { name: "Artikel", dataName: "artikel" },
    { name: "Aantal", dataName: "quantity" },
    { name: "Prijs", dataName: "salesprice" },
  ];

  return (
    <>
      {!loading && (
        <Table data={order} columnsMapping={orderHistoryColumnsTable} />
      )}
      <hr />
      <h3 align="center">{"Totale bedrag: " + calculateOrderTotal(order)}</h3>
    </>
  );
}

function mapStateToProps(state) {
  return {
    orderHistory: state.orderHistory.orderHistory,
    userId: state.login.data.user_id,
    orderId: state.orderHistory.order_id,
  };
}

export default connect(mapStateToProps, {
  fetchOrderHistory,
  setOrderId,
})(SingleOrder);
